/**
 * How a live wait estimate reads on screen. Rounded to what the estimate can
 * honestly claim: 5 minutes under an hour, a quarter hour above. Each screen
 * maps `kind` to its own translation key.
 */
export type WaitTimeKind = 'none' | 'minutes' | 'hours' | 'hoursMinutes'

export interface RoundedWaitTime {
  kind: WaitTimeKind
  params: { minutes?: number; hours?: number }
}

/** null when there is no estimate — the screen then shows nothing. */
export function roundWaitTime(minutes: number | null | undefined): RoundedWaitTime | null {
  if (minutes == null || !Number.isFinite(minutes)) return null
  if (minutes <= 0) return { kind: 'none', params: {} }
  const fives = Math.max(5, Math.round(minutes / 5) * 5)
  if (fives < 60) return { kind: 'minutes', params: { minutes: fives } }
  const total = Math.round(minutes / 15) * 15
  const hours = Math.floor(total / 60)
  const rest = total % 60
  return rest === 0
    ? { kind: 'hours', params: { hours } }
    : { kind: 'hoursMinutes', params: { hours, minutes: rest } }
}
